// extracted by mini-css-extract-plugin
export default {"cls1":"UPCsbbjgAOS7EfVTxbSu","cls2":"zq4wzuCCqhmwL6pd3aT6 UPCsbbjgAOS7EfVTxbSu","isNoTouchDevice":"HGpQh2nvSkxerEwgEAC4"};